{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://schemas.fortemi.dev/knowledge-shard/1.2.0/full-v1/signature.schema.json",
  "title": "Fortemi Knowledge Shard signature envelope",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "format_version",
    "signer",
    "manifest_digest",
    "blob_digests",
    "signature"
  ],
  "properties": {
    "format_version": {
      "const": "1"
    },
    "signer": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "key_id",
        "algorithm",
        "public_key"
      ],
      "properties": {
        "key_id": {
          "type": "string",
          "minLength": 1,
          "maxLength": 256
        },
        "algorithm": {
          "const": "ed25519"
        },
        "public_key": {
          "type": "string",
          "pattern": "^[A-Za-z0-9_-]{43}$"
        }
      }
    },
    "manifest_digest": {
      "$ref": "#/$defs/sha256"
    },
    "blob_digests": {
      "type": "array",
      "maxItems": 64,
      "uniqueItems": true,
      "items": {
        "type": "string",
        "pattern": "^[0-9a-f]{64}$"
      }
    },
    "signature": {
      "type": "string",
      "pattern": "^[A-Za-z0-9_-]{86}$"
    }
  },
  "$defs": {
    "sha256": {
      "type": "string",
      "pattern": "^[0-9a-f]{64}$"
    }
  }
}
